import { Component, OnInit, Input, EventEmitter, Output, OnChanges } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { LocationsService } from "../../services/locations/locations.service";
import { trigger, state, style, animate, transition } from "@angular/animations";
import { MenuStore } from "../../store/menu/menu.store";
import { MenuService } from "../../services/menu/menu.service";
import { OrderService } from "../../services/order/order.service";
import * as $ from "jquery";

@Component({
  selector: "menu-sidebar",
  templateUrl: "./menu-sidebar.component.html",
  styleUrls: ["./menu-sidebar.component.scss"],
  animations: [
    trigger("menuSlideIn", [
      state(
        "start",
        style({
          transform: "translateX(500px)",
          opacity: 0
        })
      ),
      state(
        "end",
        style({
          transform: "translateX(0)",
          opacity: 1
        })
      ),
      transition("start => end", animate("500ms cubic-bezier(0.075, 0.82, 0.165, 1)"))
    ])
  ]
})
export class MenuSidebarComponent implements OnInit, OnChanges {
  public rodAssets = {
    menuBG: "./assets/menu/sidebar-menu-bg.jpg"
  };

  public locationsMenuIsActive: boolean = true;
  public showMenuTitle: boolean = false;
  public itemCategoriesMenuIsActive: boolean = false;
  public breadCrumbsActive: boolean = false;
  public breadCrumbs: Array<string> = [];
  public state: string = "start";
  public menu;
  public locationID;
  public locationName;
  public menuCategoriesIsActive: boolean = false;
  public menuLoading: boolean = false;
  public itemModifiers;

  @Input() activeLocation: string;
  @Input() locations;
  @Input() locationsLoading;

  @Output() activateLocation: EventEmitter<any> = new EventEmitter();
  @Output() filterMenu: EventEmitter<any> = new EventEmitter();

  public menuCategories: Array<string> = ["ALL"];

  constructor(
    private _router: Router,
    private _activeRoute: ActivatedRoute,
    private _locationsService: LocationsService,
    private _menuStore: MenuStore,
    private _menuService: MenuService,
    private _orderService: OrderService
  ) {}

  ngOnInit() {
    //Get the menu
    this.menu = this._menuStore.getMenu();

    //Get the location ID
    this.locationID = this._orderService.getLocationID();
  }

  // Runs when user clicks sidebar location and grabs the menu
  public activateLocationMenu(id, locationName) {
    this.locationName = locationName.replace(/\s/g, "-").toLowerCase();
    this._router.navigate(["/menu", "all-locations"]);
    this.locationsMenuIsActive = false;
    this.menuLoading = true;

    // Tells the menu component that the menu is loading.
    this.activateLocation.emit({
      menuLoading: this.menuLoading,
      chooseLocations: false
    });

    // Updates the location ID Observable
    let locationID;
    if (typeof id !== "string") {
      locationID = id.source.value;
    } else {
      locationID = id;
      this._orderService.updateLocationID(locationID);
      this._locationsService.updateLocationName(locationName);
    }

    // Finally goes off to get the menu by location id
    this._menuService.getMenuByLocationID(locationID).subscribe(
      result => {
        try {
          // console.log('menu location received');
          // Organizes the menu based on the categories needed, price values, etc.
          this._menuStore.organizeMenu(result).then(menu => {
            console.log("RESOLVED PROMISE MENU", menu);
            this._menuStore.attachMenuItemDescriptions(menu).then(menu => {
              console.log("AFTER ANOTHER PROMISE MENU", menu);

              // Build the categories in the sidebar based on the items
              this._buildSidebarCategoryArray();
              // Removes undefined if in the array
              this._removeUndefinedFromMenuCategory();
              //activates the first in the array by default
              this._activateFirstCategoryInMenu();

              // Sets the active location into the breadcrumb
              this.breadCrumbs.push(locationName);
              this.activeLocation = locationName;
              // Sets state for updating the UI
              this.itemCategoriesMenuIsActive = true;
              this.breadCrumbsActive = true;
              this.showMenuTitle = true;
              this.menuLoading = false;
              this.state = "end";

              if (this.activateLocation) {
                this.activateLocation.emit({
                  locationID: locationID,
                  locationName: locationName,
                  menuLoading: this.menuLoading
                });
              }
              this.menuCategoriesIsActive = true;

              this.state = "end";
            });
          });
        } catch (error) {
          console.log("could not organize menu", error);
        }
      },
      error => {
        console.log("could not get menu by location id");
      }
    );
  }

  private _activateFirstCategoryInMenu() {
    let list = $(".sidebar-menu-item-categories")
      .find("ul")
      .find("li");

    // list.map((index, listItem) => {
    //   if (index === 0) {
    //     listItem.classList.add('acitve');
    //   }
    // });
    for (let i = 0; i < list.length; i++) {
      if (i === 0) {
        list[i].classList.add("active");
      }
    }
  }

  private _removeUndefinedFromMenuCategory() {
    this.breadCrumbs.forEach((crumb, i) => {
      if (crumb === undefined) {
        this.breadCrumbs.splice(i, 1);
      }
    });
  }

  private _buildSidebarCategoryArray() {
    this.menu.source.value.forEach(item => {
      let category = item.category;
      let id = item.id;

      if (this._findCategoryMatch(category) === undefined) {
        console.log(category);
        this.menuCategories.push(category);
      }
    });
  }

  private _findCategoryMatch(category) {
    // this.menuCategories.forEach((index, menuCategory) => {
    //   if (menuCategory === category) {
    //     return true;
    //   }
    // });

    for (let j = 0; this.menuCategories.length > j; j++) {
      if (this.menuCategories[j] === category) {
        return true;
      }
    }
  }

  public filterByCategory(category, event) {
    this.highlightCategory(event);
    this.filterMenu.emit({ menuCategory: category });
    console.log("category", category);
    this.itemCategoriesMenuIsActive = true;
  }

  private highlightCategory(event) {
    let activelistitem = $(".sidebar-menu-item-categories")
      .find("ul")
      .find("li.active");
    activelistitem.removeClass("active");
    if (event) {
      event.target.classList.add("active");
    }
  }

  public goBackToLocations() {
    this.menuCategoriesIsActive = false;
    this.locationsMenuIsActive = true;
    this.breadCrumbsActive = false;
    this._router.navigate(["/menu"]);
    this.activateLocation.emit({
      chooseLocations: true
    });
    this.breadCrumbs = [];
    this.state = "start";
  }

  ngOnChanges(changes) {
    if (changes.activeLocation !== undefined) {
      if (typeof changes.activeLocation.currentValue == "string") {
        this.activateLocationMenu(this.locationID, changes.activeLocation.currentValue);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/menu/menu-sidebar/menu-sidebar.component.ts